const interfaceTranslations = {
  selectedCountryAriaLabel: "منتخب ملک",
  noCountrySelected: "کوئی ملک منتخب نہیں کیا گیا۔",
  countryListAriaLabel: "ممالک کی فہرست",
  searchPlaceholder: "تلاش کریں۔",
  zeroSearchResults: "کوئی نتیجہ نہیں",
  oneSearchResult: "1 نتیجہ ملا",
  multipleSearchResults: "${count} نتائج ملے",
  // additional countries (not supported by country-list library)
  ac: "ایسنشن جزیرہ",
  xk: "کوسوو"
};
export default interfaceTranslations;